import * as React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";

/**
 * Reusable delete confirmation dialog.
 *
 * Props:
 *  - open: bool
 *  - selectedCount: number — how many items are being deleted
 *  - onCancel: func
 *  - onConfirm: func
 *  - itemLabel: string (default "item") — singular label for the item type
 */
export default function DeleteConfirmDialog({
  open,
  selectedCount,
  onCancel,
  onConfirm,
  itemLabel = "item",
}) {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="delete-dialog-title"
      aria-describedby="delete-dialog-description"
    >
      <DialogContent>
        <Typography>
          Are you sure you want to delete the selected {selectedCount}{" "}
          {itemLabel}
          {selectedCount > 1 ? "s" : ""}?{" "}
          <br /> This action cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ "& > :not(style)": { m: 1.5, width: "100%" } }}>
        <Button variant="contained" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="contained" color="error" onClick={onConfirm}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}

DeleteConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  selectedCount: PropTypes.number.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  itemLabel: PropTypes.string,
};
